import { KeyboardEventHandler } from 'react';
import styled from '@emotion/styled';
import { SearchInput } from '../../../../components/common/search-input/SearchInput';
import { Css, Responsive } from '../../../../ui';

interface IShopDineRelaxSearchBarProps {
	value: string;
	onValueChange: (value: string) => void;
	onKeyUp?: KeyboardEventHandler<HTMLInputElement>;
	onQuerySubmit: (query: string) => void;
	isInvalid: boolean;
}

export const ShopDineRelaxSearchBar = ({
	onKeyUp,
	value,
	onValueChange,
	onQuerySubmit,
	isInvalid = false,
}: IShopDineRelaxSearchBarProps) => {
	const updateQuery = (e: React.ChangeEvent<HTMLInputElement>) => {
		onValueChange(e.target.value);
	};

	const onInputClear = () => {
		onValueChange('');
		onQuerySubmit('');
	};

	return (
		<Wrapper>
			<SearchInput
				value={value}
				label="Search shops, restaurants, facilities"
				onChange={(e) => updateQuery(e)}
				onClear={onInputClear}
				onKeyUp={onKeyUp}
				isInvalid={isInvalid}
			/>
		</Wrapper>
	);
};

const Wrapper = styled.div`
	position: relative;
	width: 100%;
	display: flex;
	margin: 0;
	padding: 0;
	flex-direction: row;
	gap: ${Css.pxToRem(16)};

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		flex-direction: column;
		gap: ${Css.pxToRem(8)};
	}
`;
